export class Config {
  static serverUrl = 'https://app-ws-dev.overit.it';
  static MSAL_REDIRECT_URI = 'https://app-admin-dev.overit.it';
}
